export * from './widgets.component';
